// extracted by mini-css-extract-plugin
export default {"root":"syJq5W8VZ9","title_placeholder":"Y6J2VmAJ6M","title":"RpM_jbQQ1E","media":"Cb4GPgPUAe","content":"VsazSysy7S"};